import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/pages/index/index'
import About from '@/pages/about/about'
import Case from '@/pages/case/case'
import Contact from '@/pages/contact/contact'
import Product from '@/pages/product/product'
import Product1 from '@/pages/product/product1'
import Product2 from '@/pages/product/product2'
import Product3 from '@/pages/product/product3'
import Product4 from '@/pages/product/product4'
import Product5 from '@/pages/product/product5'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Default',
      component: Index
    },
    // {
    //   path: '*',
    //   redirect: '/index'
    // },
    {
      path: '/home',
      name: 'Index',
      component: Index
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/case',
      name: 'Case',
      component: Case
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/product',
      name: 'Product',
      component: Product
    },
    {
      path: '/product1',
      name: 'Product1',
      component: Product1
    },
    {
      path: '/product2',
      name: 'Product2',
      component: Product2
    },
    {
      path: '/product3',
      name: 'Product3',
      component: Product3
    },
    {
      path: '/product4',
      name: 'Product4',
      component: Product4
    },
    {
      path: '/product5',
      name: 'Product5',
      component: Product5
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js